import { stringify } from "qs";
import { getHeaders, makeRequest, fetch } from "$utils/utils";
import config from "./config";
import constants from "$utils/constants";

const url = config.api_url;

export enum ERRORS {
  USER_EXISTS = "Cet utilisateur existe déjà. Veuillez modifier les informations ou annuler la création",
  ADD_ERROR = "Une erreur s'est produite lors de l'ajout",
  UPDATE_ERROR = "Une erreur s'est produite lors de l'édition",
  DELETE_ERROR = "Une erreur s'est produite lors de la suppression",
  MISSING_FIELD = "Donnée manquante !",
}

export const ROLES = {
  ADMIN: process.env.REACT_APP_AUTH_ROLE_ADMIN || "",
  CLIENT: process.env.REACT_APP_AUTH_ROLE_CLIENT || "",
};

// pagination
export const getCoordinators = async (params) => {
  try {
    const { data } = await fetch(`/api/user/coordinators?${stringify(params)}`);
    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

// Check if user exists by email
export const VerifyUserEmail = async (token: string, email: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/user/email/check/${encodeURIComponent(email)}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    // The new endpoint returns { exists: boolean }
    return res?.data?.exists === true;
  } catch (err: any) {
    // For any error, assume email doesn't exist to avoid blocking the form
    return false;
  }
};

export const FetchUsers = async (
  token: string,
  filters: {
    company?: string | null;
    warehouse?: string;
    role?: string;
    isDisable?: boolean;
    isOnlyContact?: boolean;
    newuser?: boolean;
    auth0Id?: string;
    [key: string]: any;
  } = {},
  page?: number,
  pageSize?: number
) => {
  try {
    const params: any = {
      ...filters,
    };

    if (page) params.page = page;
    if (pageSize) params.rowsPerPage = pageSize;

    // Clean undefined/null params to avoid sending "undefined" string
    Object.keys(params).forEach(
      (key) =>
        (params[key] === undefined || params[key] === null) &&
        delete params[key]
    );

    // Build request URL and query string from params
    const requestUrl = `${url}/api/user`;
    const queryString = stringify(params, { skipNulls: true });
    const fullUrl = queryString ? `${requestUrl}?${queryString}` : requestUrl;

    const res = await makeRequest(
      fullUrl,
      "get",
      undefined, // No body for GET request
      getHeaders(token)
    );

    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when fetching users");
    }
    const response = res.data.data;
    return response;
  } catch (err) {
    return [];
  }
};

export const AddUsers = async (token: string, data: any) => {
  try {
    const res = await makeRequest(
      `${url}/api/user`,
      "POST",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("user already exists")) {
      error = ERRORS.USER_EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const EditUsers = async (token: string, data: any, id: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/user/${id}`,
      "PUT",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when editing user");
    }
    return res.data.data;
  } catch (err) {
    return { error: ERRORS.UPDATE_ERROR };
  }
};

export const VerifyUsers = async (email: string) => {
  try {
    const res = await makeRequest(
      `${(constants.API.ENDPOINTS as any).USER.VERIFY}`,
      "POST",
      { email }
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when getting user");
    }
    return res.data.data;
  } catch (err) {
    return { error: err.response?.data.message || err.message };
  }
};

export const DeleteUser = async (token: string, userId: string) => {
  try {
    const url = `${(constants.API.ENDPOINTS as any).USER.USER}/${userId}`;
    const res = await makeRequest(url, "DELETE", undefined, getHeaders(token));
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when deleting user");
    }
    return res.data.data;
  } catch (err) {
    return { error: ERRORS.DELETE_ERROR };
  }
};

export const getUserById = async (id: string) => {
  try {
    const res = await makeRequest(`${url}/api/user/${id}`, "GET");

    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when fetching user by it's id");
    }

    const response = res.data.data;
    return response;
  } catch (err) {
    return null;
  }
};
